export const AIProvider = {
    OPENAI: 'OpenAI',
    IMAGE_GENERATION: 'Image Generation',
    ANTHROPIC: 'Anthropic',
    GOOGLE: 'Google',
    AUTOSELECTION: 'Auto Selection',
    PERPLEXITY: 'Perplexity',
    xAI: 'xAI',
    DEEPSEEK: 'DeepSeek',
    DEEPSEEK_REASONING: 'DeepSeek Reasoning',
    LLAMA: 'Meta'
};